import React from "react"
import PropTypes from "prop-types"
import ItemNameValueShape from "../../state/shapes/ItemNameValueShape"
import Widget from "../layout/widget/Widget"
import GaugeChart from "../charts/generic/GaugeChart"
import { CHARTS } from "../../constants"

function LeaversInFirst100Days({ exportEndpoint, appliedFilters, data, subtitleKey, sampleSize }) {
  const stopsValues = [
    [0.15, CHARTS.trafficLightColours.green], // green
    [0.3, CHARTS.trafficLightColours.amber], // yellow
    [0.5, CHARTS.trafficLightColours.red] // red
  ]

  const titleKey = "Widgets.LeaversFirst100Days.Title"
  return (
    <Widget
      columns={1}
      helpKey="Widgets.Leavers100Days.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      titleKey={titleKey}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <GaugeChart data={data[0]} stopsValues={stopsValues} titleKey={titleKey} subtitleKey={subtitleKey}/>
    </Widget>
  )
}

LeaversInFirst100Days.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameValueShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default LeaversInFirst100Days



// WEBPACK FOOTER //
// ./src/components/widgets/LeaversInFirst100Days.jsx